module.exports = __webpack_public_path__ + "img/myself02-web.2bf60212.png";